import { PUBLIC_APP_ROUTE_PATHS } from '@/shared/constants/app-route-paths';
import { pathnameMatchesSomeRoute } from '@/shared/functions/route-path-matches';

export function isPublicRoute(pathname: string): boolean {
	return pathnameMatchesSomeRoute(pathname, PUBLIC_APP_ROUTE_PATHS);
}
